import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "label"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 0,
  class: "read-more flex items-center"
}
const _hoisted_4 = {
  key: 1,
  class: "read-less flex items-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_input = _resolveComponent("q-input")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.editing || _ctx.disableEditing)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _renderSlot(_ctx.$slots, "label", { inputState: _ctx.inputState }, () => [
            _createElementVNode("label", null, _toDisplayString(_ctx.label), 1)
          ], true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["value", { 'static': !_ctx.editing || _ctx.disableEditing, editing: _ctx.editing && !_ctx.disableEditing }])
    }, [
      (!_ctx.editing || _ctx.disableEditing)
        ? _renderSlot(_ctx.$slots, "static", {
            key: 0,
            inputState: _ctx.inputState
          }, () => [
            (_ctx.inputState.value)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: _normalizeClass({ expanded: _ctx.expanded })
                }, _toDisplayString(_ctx.inputState.value), 3))
              : (_openBlock(), _createElementBlock("span", _hoisted_2, "-")),
            (_ctx.expandable && _ctx.overflow)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  class: "expand q-mt-sm",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.expanded = !_ctx.expanded))
                }, [
                  (!_ctx.expanded)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createVNode(_component_q_btn, {
                          class: "btn secondary",
                          unelevated: "",
                          flat: "",
                          dense: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_icon, {
                              name: "expand_more",
                              size: "22px"
                            }),
                            _cache[2] || (_cache[2] = _createElementVNode("span", null, "Read more", -1))
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.expanded)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createVNode(_component_q_btn, {
                          class: "btn secondary",
                          unelevated: "",
                          flat: "",
                          dense: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_icon, {
                              name: "expand_less",
                              size: "22px"
                            }),
                            _cache[3] || (_cache[3] = _createElementVNode("span", null, "Read less", -1))
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ], true)
        : _renderSlot(_ctx.$slots, "input", {
            key: 1,
            inputState: _ctx.inputState
          }, () => [
            _createVNode(_component_q_input, {
              label: _ctx.inputState.label,
              modelValue: _ctx.inputState.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.inputState.value) = $event)),
              type: "textarea",
              autogrow: ""
            }, null, 8, ["label", "modelValue"])
          ], true)
    ], 2)
  ], 64))
}